<div class="container">
    <div class="config-tab-title-area">
        <smart-icon name="visualization" class="light"></smart-icon>
        <span class="h3-regular config-tab-title">{{'dashboard.visualization_settings' |
            stringLiterals}}</span>
    </div>
    <div class="tam-form-field setting-body">
        <div class="row first-row" tid="vs_category" *ngIf="tile.visualization.type===visualizationType.PIE_CHART||tile.visualization.type===visualizationType.COLUMN_CHART ||
            tile.visualization.type===visualizationType.BAR_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.category' |
                    stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [filterable]="true" textField="title"
                valueField="guid" [(ngModel)]="data.categoryAxis" [data]="categoryData()"
                (filterChange)="handleFilterCategory($event)" (valueChange)="valueChange('categoryAxis')">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && !data.categoryAxis">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_value" *ngIf="tile.visualization.type===visualizationType.PIE_CHART||tile.visualization.type===visualizationType.COLUMN_CHART ||
            tile.visualization.type===visualizationType.BAR_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.value' |
                    stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="valueData()" [filterable]="true"
                textField="title" valueField="guid" [(ngModel)]="data.series" (filterChange)="handleFilterValue($event)"
                (valueChange)="valueChange('series')">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && !data.series">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_display_setting" *ngIf="tile.visualization.type===visualizationType.PIE_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.display_settings' |
                    stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="displaySettingOptions" textField="name"
                valueField="id" [(ngModel)]="data.displaySetting" (valueChange)="valueChange('displaySetting')">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && !data.displaySetting">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_value_sort" *ngIf="tile.visualization.type===visualizationType.COLUMN_CHART ||
        tile.visualization.type===visualizationType.BAR_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.value_sort' |
                    stringLiterals}}</span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="categorySortOptions" textField="name"
                valueField="id" [(ngModel)]="data.categorySort" (valueChange)="valueChange('categorySort')">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && data.categoryCount && !data.categorySort">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_category_count" *ngIf="tile.visualization.type===visualizationType.COLUMN_CHART ||
        tile.visualization.type===visualizationType.BAR_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.category_count' |
                    stringLiterals}}</span>
            </div>
            <kendo-numerictextbox [(ngModel)]="data.categoryCount" [min]="1" [max]="50" format="n"
                (valueChange)="valueChange('categoryCount')">
            </kendo-numerictextbox>
            <div class="tam-form-help" *ngIf="submitted && data.categorySort && !data.categoryCount">
                <span class="required-field">{{'dashboard.value_should_be_between_1_and_10' |
                    stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_blank_category" *ngIf="tile.visualization.type===visualizationType.PIE_CHART||tile.visualization.type===visualizationType.COLUMN_CHART ||
        tile.visualization.type===visualizationType.BAR_CHART">
            <label tam-checkbox [(ngModel)]="enableBlankCategory" (click)="changeEnableBlankCategory()">
                <span class="tam-form-label">{{'dashboard.do_not_include_blank_item_as_category' |
                    stringLiterals}}</span>
            </label>
        </div>
        <div class="row control_distance" tid="vs_calculate_value_separately"
            *ngIf="tile.visualization.type === visualizationType.PIE_CHART">
            <label tam-checkbox [(ngModel)]="enableUnnestColumn" (click)="changeEnableUnnestColumn()"
                [disabled]="!unusableUnnestColumn">
                <span class="tam-form-label">{{'dashboard.calculate_category_value_separately' | stringLiterals}}</span>
            </label>
        </div>
        <div class="row" tid="vs_x_axis" *ngIf="tile.visualization.type === visualizationType.LINE_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.x_axis' | stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="xAxisData()" [filterable]="true"
                textField="title" valueField="guid" [(ngModel)]="data.categoryAxis"
                (filterChange)="handleFilterXAxis($event)" (valueChange)="valueChange('categoryAxis')">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && !data.categoryAxis">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_series" *ngIf="tile.visualization.type === visualizationType.LINE_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.series' | stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="seriesData()" [filterable]="true"
                textField="title" valueField="guid" [(ngModel)]="data.series"
                (filterChange)="handleFilterSeries($event)" (valueChange)="valueChange('series')">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && !data.series">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_groupby" *ngIf="tile.visualization.type === visualizationType.LINE_CHART">
            <div class="tam-form-label">
                <span>{{'dashboard.group_by' | stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="groupByData()" [filterable]="true"
                textField="title" valueField="guid" [(ngModel)]="data.groupBy"
                (filterChange)="handleFilterGroupBy($event)" (valueChange)="valueChange('groupBy')">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && !data.groupBy">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row first-row" tid="vs_column" *ngIf="tile.visualization.type === visualizationType.VALUE">
            <div class="tam-form-label">
                <span>{{'dashboard.column' | stringLiterals}} <span class="required-field">*</span></span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="columnData()" [filterable]="true"
                textField="title" valueField="guid" [(ngModel)]="data.column"
                (filterChange)="handleFilterColumn($event)" (valueChange)="updateSummaries()">
            </kendo-combobox>
            <div class="tam-form-help" *ngIf="submitted && !data.column">
                <span class="required-field">{{'general.required_error_message' | stringLiterals}}</span>
            </div>
        </div>
        <div class="row" tid="vs_summaries" *ngIf="tile.visualization.type === visualizationType.VALUE">
            <div class="tam-form-label">
                <span>{{'dashboard.summaries' | stringLiterals}}</span>
            </div>
            <kendo-combobox [popupSettings]="{appendTo: 'component'}" [data]="summaryOptions" textField="name"
                valueField="id" [(ngModel)]="data.summaries" [disabled]="summaryDisabled"
                (valueChange)="valueChange('summaries')">
            </kendo-combobox>
        </div>
        <div class="row" *ngIf="tile.visualization.type === visualizationType.VALUE">
            <tile-conditional-formatting [config]="tile" [hideBackground]="true"
                [fields]="[{ title: 'Value', guid: 'ke48d5ac4b8746e5a700e03822e0d978' }]"></tile-conditional-formatting>
        </div>
    </div>
</div>